import {type NavigationGuardNext, type RouteLocationNormalized} from 'vue-router';
import {getProjectsFromTrashResolver,} from '@domains/dashboard/resolvers';
import {getContainersResolver} from "@domains/dashboard/resolvers/get-containers.resolver";
import {DashboardNs} from "@shared/types";

export const dashboardRoutes = [
    {
        path: '/dashboard',
        name: DashboardNs.DashboardRouteEnums.DASHBOARD,
        beforeEnter: [
            (to: RouteLocationNormalized, from: RouteLocationNormalized, next: NavigationGuardNext): void => {
                getContainersResolver(to, from, next);
            },
        ],
        component: () => import('@domains/dashboard/views/dashboard.layout.vue'),
        children: [
            {
                path: '',
                name: DashboardNs.DashboardRouteEnums.PROJECTS,
                component: () => import('@domains/dashboard/views/projects.view.vue'),
            },
            {
                path: '/trash',
                name: DashboardNs.DashboardRouteEnums.TRASH,
                beforeEnter: (to: RouteLocationNormalized, from: RouteLocationNormalized, next: NavigationGuardNext) => {
                    getProjectsFromTrashResolver(to, from, next);
                },
                component: () => import('@domains/dashboard/views/trash.view.vue'),
                meta: {
                    userRole: ["ADMIN", "OWNER"],
                },
            },
        ],
    },
];
